<div class="filters" [ngClass]="{'filters_poDetail': this.gridOptions?.isPurchaseOrder}">
  <div class="filters_title">
    <h1>Columns</h1>
    <app-button
      [buttonSize]="'action'"
      [buttonStyle]="'text'"
      (click)="resetColumn()"
      >Reset</app-button
    >
  </div>
  <div class="filters_search_input">
    <input
    #myInput
    placeholder="Search"
    [(ngModel)]="searchedText"
    (input)="filterItem(myInput.value)"
  />
  </div>
  <ng-container *ngFor="let x of columns">
    <div
    *ngIf="(x.colId != '0') && (x.userProvidedColDef.headerName || x.userProvidedColDef.field)"
      class="filters_filter"
      (click)="setColumns(x)"
    >
      <div class="input-container">
        <div class="input-container_label m-0">
          <img
            src="../../../assets/images/tick.svg"
            alt=""
            *ngIf="x.visible"
            class="me-2"
          />
          <span [ngClass]="{ 'gray-text': !x.visible }">
            {{x.name ? x.name:
              x.userProvidedColDef.headerName
                ? x.userProvidedColDef.headerName
                : x.userProvidedColDef.field
            }}
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
